import { Component, OnInit, Inject, Optional } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { EmployeeService } from 'src/app/_services/employee.service';
import { EmployeeIdariRequest } from 'src/app/_model/request/EmployeeIdariRequest';
import { ToastrService } from 'ngx-toastr';
import {DialogCloseData} from '../../../_model/models';
import {DIALOG_OPERATIONS} from '../../../_utils/constants';

@Component({
  selector: 'app-employeeIdari-delete',
  templateUrl: './employeeIdari-delete.component.html',
  styleUrls: ['./employeeIdari-delete.component.css'],
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule
  ]
})
export class EmployeeIdariDeleteComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<EmployeeIdariDeleteComponent>,
    private employeeService: EmployeeService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: EmployeeIdariRequest,
    private toastr: ToastrService) { }

  ngOnInit() {
  }
  deleteEmployeeIdari(employeeIdari: EmployeeIdariRequest) {
    this.employeeService.deleteEmployeeIdari(employeeIdari.id).subscribe(result => {
        this.toastr.success('Silme işlemi başarılı', '');
        this.dialogRef.close(new DialogCloseData(DIALOG_OPERATIONS.DELETE, result.responseData.item));
    }, error => {
        this.toastr.error(error.error.msg, 'Hata');
        this.dialogRef.close();
    });
}


}
